module.exports = __webpack_public_path__ + "img/rhoutdoor.b8ff6771.png";